export default __webpack_public_path__ + "static/media/stars.eee7f88a.svg";